var $ = require('jquery'); 
$(document).ready(function () {
    var isload = false;
    var mainskip = 10, take = 0;
    
    var isPressreleases = $('.pressmore').length;
if(isPressreleases>0){
    setTimeout(function () {
        loadPageData(mainskip, take);
    }, 1000);
    function loadPageData(skip, take) {
        var url = window.location.pathname + "/GetMoreItems";
        $.ajax({
            url: url,
            method: 'post',
            dataType: "html",
            data: { skip: skip, take: take },
            success: function (response) {
                if (response.length > 0) {
                    var insightsresult = response;
                    if (insightsresult != null && insightsresult != undefined) {
                        var strtindex = insightsresult.indexOf("<!-- pressreleases  start -->");
                        var endindex = insightsresult.indexOf("<!-- pressreleases  end -->");
                        var res = insightsresult.substring(strtindex, endindex);
                        $('.pressmore').html('');
                        $('.pressmore').html(res);
                    }
                    return true;
                }
            },
            error: function (err) {
               
            }
        });
    }
    function loadSearchData(searchtext) {
            var token = $('input[name="__RequestVerificationToken"]').val();
        var url = window.location.pathname + "/GetSearchItems";
        $.ajax({
            url: url,
            method: 'post',
            dataType: "html",
                data: { __RequestVerificationToken: token, searchText: searchtext },
            success: function (response) {
                if (response.length > 0) {
                    var insightsresult = response;
                    if (insightsresult != null && insightsresult != undefined) {
                        var strtindex = insightsresult.indexOf("<!-- pressreleases  start -->");
                        var endindex = insightsresult.indexOf("<!-- pressreleases  end -->");
                        var res = insightsresult.substring(strtindex, endindex);
                        $('#Divloadmorepress').html('');
                        $('#Divloadmorepress').html(res);
                    }
                    return true;
                }
            },
            error: function (err) {
               
            }
        });
    }
    $("#press-filter").keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            var filter = $(this).val();
            loadSearchData(filter);
        }
    });
}
});
$('.copyclipboard').click(function (e) {
    e.preventDefault();
    var copyText = $(this).attr('href');
    document.addEventListener('copy', function (e) {
        e.clipboardData.setData('text/plain', copyText);
        e.preventDefault();
    }, true);
    document.execCommand('copy');
});
$(window).on('hashchange load', function (e) {
    var url = window.location.href;
    if(url.indexOf('#')!=-1){
    var arr = url.split('#')[1];
    var htags = "#" + arr;
        if ($(htags).length) {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(htags).offset().top - 250
    }, 500);
}
    }
});